"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidApiKey = exports.InvalidToken = exports.Uninitialised = exports.TooManyRequests = exports.NotFound = exports.Forbidden = exports.Unauthorized = exports.BadRequest = exports.HttpError = void 0;
// eslint-disable-next-line max-classes-per-file
class HttpError extends Error {
    constructor(code, message) {
        super(message);
        this.name = this.constructor.name;
        this.code = code;
    }
}
exports.HttpError = HttpError;
class BadRequest extends HttpError {
    constructor(message) {
        super(400, message !== null && message !== void 0 ? message : 'Bad Request');
    }
}
exports.BadRequest = BadRequest;
class Unauthorized extends HttpError {
    constructor(message) {
        super(401, message !== null && message !== void 0 ? message : 'Authorization required');
    }
}
exports.Unauthorized = Unauthorized;
class Forbidden extends HttpError {
    constructor(message) {
        super(403, message !== null && message !== void 0 ? message : 'You do not have permission to access this resource');
    }
}
exports.Forbidden = Forbidden;
class NotFound extends HttpError {
    constructor(message) {
        super(404, message !== null && message !== void 0 ? message : 'Not found');
    }
}
exports.NotFound = NotFound;
class TooManyRequests extends HttpError {
    constructor(message) {
        super(429, message !== null && message !== void 0 ? message : 'You have exceeded the rate limit');
    }
}
exports.TooManyRequests = TooManyRequests;
class Uninitialised extends Error {
    constructor(message) {
        super(message !== null && message !== void 0 ? message : 'Authentication provider has not been initialised with token');
    }
}
exports.Uninitialised = Uninitialised;
class InvalidToken extends Error {
    constructor(message) {
        super(message !== null && message !== void 0 ? message : 'Invalid/expired refresh token');
    }
}
exports.InvalidToken = InvalidToken;
class InvalidApiKey extends Error {
    constructor(message) {
        super(message !== null && message !== void 0 ? message : 'Incorrect api key');
    }
}
exports.InvalidApiKey = InvalidApiKey;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2Vycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxnREFBZ0Q7QUFDaEQsTUFBYSxTQUFVLFNBQVEsS0FBSztJQUdsQyxZQUFZLElBQVksRUFBRSxPQUFlO1FBQ3ZDLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUNmLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUM7UUFDbEMsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7SUFDbkIsQ0FBQztDQUNGO0FBUkQsOEJBUUM7QUFFRCxNQUFhLFVBQVcsU0FBUSxTQUFTO0lBQ3ZDLFlBQVksT0FBZ0I7UUFDMUIsS0FBSyxDQUFDLEdBQUcsRUFBRSxPQUFPLGFBQVAsT0FBTyxjQUFQLE9BQU8sR0FBSSxhQUFhLENBQUMsQ0FBQztJQUN2QyxDQUFDO0NBQ0Y7QUFKRCxnQ0FJQztBQUVELE1BQWEsWUFBYSxTQUFRLFNBQVM7SUFDekMsWUFBWSxPQUFnQjtRQUMxQixLQUFLLENBQUMsR0FBRyxFQUFFLE9BQU8sYUFBUCxPQUFPLGNBQVAsT0FBTyxHQUFJLHdCQUF3QixDQUFDLENBQUM7SUFDbEQsQ0FBQztDQUNGO0FBSkQsb0NBSUM7QUFFRCxNQUFhLFNBQVUsU0FBUSxTQUFTO0lBQ3RDLFlBQVksT0FBZ0I7UUFDMUIsS0FBSyxDQUFDLEdBQUcsRUFBRSxPQUFPLGFBQVAsT0FBTyxjQUFQLE9BQU8sR0FBSSxvREFBb0QsQ0FBQyxDQUFDO0lBQzlFLENBQUM7Q0FDRjtBQUpELDhCQUlDO0FBRUQsTUFBYSxRQUFTLFNBQVEsU0FBUztJQUNyQyxZQUFZLE9BQWdCO1FBQzFCLEtBQUssQ0FBQyxHQUFHLEVBQUUsT0FBTyxhQUFQLE9BQU8sY0FBUCxPQUFPLEdBQUksV0FBVyxDQUFDLENBQUM7SUFDckMsQ0FBQztDQUNGO0FBSkQsNEJBSUM7QUFFRCxNQUFhLGVBQWdCLFNBQVEsU0FBUztJQUM1QyxZQUFZLE9BQWdCO1FBQzFCLEtBQUssQ0FBQyxHQUFHLEVBQUUsT0FBTyxhQUFQLE9BQU8sY0FBUCxPQUFPLEdBQUksa0NBQWtDLENBQUMsQ0FBQztJQUM1RCxDQUFDO0NBQ0Y7QUFKRCwwQ0FJQztBQUVELE1BQWEsYUFBYyxTQUFRLEtBQUs7SUFDdEMsWUFBWSxPQUFnQjtRQUMxQixLQUFLLENBQUMsT0FBTyxhQUFQLE9BQU8sY0FBUCxPQUFPLEdBQUksNkRBQTZELENBQUMsQ0FBQztJQUNsRixDQUFDO0NBQ0Y7QUFKRCxzQ0FJQztBQUVELE1BQWEsWUFBYSxTQUFRLEtBQUs7SUFDckMsWUFBWSxPQUFnQjtRQUMxQixLQUFLLENBQUMsT0FBTyxhQUFQLE9BQU8sY0FBUCxPQUFPLEdBQUksK0JBQStCLENBQUMsQ0FBQztJQUNwRCxDQUFDO0NBQ0Y7QUFKRCxvQ0FJQztBQUVELE1BQWEsYUFBYyxTQUFRLEtBQUs7SUFDdEMsWUFBWSxPQUFnQjtRQUMxQixLQUFLLENBQUMsT0FBTyxhQUFQLE9BQU8sY0FBUCxPQUFPLEdBQUksbUJBQW1CLENBQUMsQ0FBQztJQUN4QyxDQUFDO0NBQ0Y7QUFKRCxzQ0FJQyJ9